import { DataBean } from "../DataBean"

export class BudgetMovementFactory extends DataBean {

    public async createBudgetRowForCreditContraCredit(idBudgetType: number, ccIDBudgetResource: number, ccIDBudgetSource: number, ccBudgetIDStr: string, creditIDBudgetResource: number, creditIDBudgetSource: number, creditBudgetIDStr: string, value: number, description: string): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "budget.Budget_createBudgetRowForCreditContraCredit_Number_Number_Number_String_Number_Number_String_Number_String",
            [idBudgetType, ccIDBudgetResource, ccIDBudgetSource, ccBudgetIDStr, creditIDBudgetResource, creditIDBudgetSource, creditBudgetIDStr, value, description]
        );
    }

    public async createBudgetRowForContraCredit(idBudgetType: number, ccIDBudgetResource: number, ccIDBudgetSource: number, ccBudgetIDStr: string, value: number, description: string, idAdquisitionItem: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "budget.Budget_createBudgetRowForContraCredit_Number_Number_Number_String_Number_String_Number",
            [idBudgetType, ccIDBudgetResource, ccIDBudgetSource, ccBudgetIDStr, value, description, idAdquisitionItem]
        );
    }

    public async createBudgetRowForCredit(idBudgetType: number, creditIDBudgetResource: number, creditIDBudgetSource: number, creditBudgetIDStr: string, value: number, description: string, idAdquisitionItem: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "budget.Budget_createBudgetRowForCredit_Number_Number_Number_String_Number_String_Number",
            [idBudgetType, creditIDBudgetResource, creditIDBudgetSource, creditBudgetIDStr, value, description, idAdquisitionItem]
        );
    }

    public async createCreditContraCreditBudget(idBudgetType: number, accountantDate: any, items: any, description: string, idEmployee: number, createPdf: boolean): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.accountant.AccountantDocument_createCreditContraCreditBudget_Number_java.util.Date_java.util.List_String_Number_Boolean",
            [idBudgetType, accountantDate, items, description, idEmployee, createPdf]
        );
    }

}